import Mask from "../Mask";
import {CSSTransition} from "react-transition-group";
import {useEffect, useState} from "react";
import {mediaMatch} from "../../utils";
import ActionSheet from "../h5/ActionSheet";
import Button from "../Button";
import {useTranslation} from "react-i18next";


export default function Modal(props) {
  const {
    children,
    visible,
    title,
    top,
    mt = '8vh',
    width = 550,
    onClose,
    footer,
    onConfirm = () => null,
  } = props;
  const { t } = useTranslation();
  const isMdMax = mediaMatch.isMdmax;
  
  const closeHandle = () => {
    if (onClose) {
      onClose(false);
    }
  };
  
  return (
    <>
      <Mask visible={visible} onClose={closeHandle}/>
      {
        !isMdMax
          ? <CSSTransition
            in={visible}
            timeout={350}
            unmountOnExit={true}
            classNames="modelTopIn">
            <div className="rounded-[12px] z-50 fixed bg-white p-[40px] pb-[25px]"
                 style={{
                   marginTop: mt,
                   top,
                   width,
                   left: '50%',
                   transform: 'translateX(-50%)',
                   minHeight: 240,
                 }}>
              {
                title
                && <div className="mb-[25px] flex justify-between items-center">
                  <p className="text-[20px]">{title}</p>
                  <i onClick={closeHandle}
                     className="cursor-pointer iconfont icon-delete text-[22px]"></i>
                </div>
              }
              {children}
              {
                footer === null
                  ? null
                  : footer
                  ? (footer)
                  : <div className="text-right pt-[20px]">
                    <Button onClick={closeHandle}
                            className="rounded-[5px] border border-[#d4d4d4] py-[8px] px-[34px] text-[14px]">{t('取消')}</Button>
                    {
                      onConfirm
                      && <Button
                        onClick={onConfirm}
                        className="rounded-[5px] bg-[#333] text-white
                               ml-[14px] py-[8px] px-[34px] text-[14px]">
                        {t('确定')}
                      </Button>
                    }
                  </div>
              }
            </div>
          </CSSTransition>
          : <ActionSheet
            visible={visible}
            onClose={closeHandle}
            title={t(title)}>
            {children}
          </ActionSheet>
      }
    </>
  );
}
